import {Pattern, match} from 'ts-pattern';

import {isNil} from 'ramda';

import {TrimLevelOption} from '@dms/api/sales';
import {GetAllMakeModelsApiResponse} from '@dms/api/shared';

interface ResolvePurchasePriceRuleLabelParams {
  key: string;
  catalogue: GetAllMakeModelsApiResponse | undefined;
  trims: TrimLevelOption[] | undefined;
}

/**
 * Catalogue model labels are prefixed with the make, which the scope line already shows.
 */
const stripMakePrefix = (modelLabel: string, makeLabel: string | undefined) => {
  const makePrefix = isNil(makeLabel) ? null : `${makeLabel} `;

  return isNil(makePrefix) || !modelLabel.startsWith(makePrefix)
    ? modelLabel
    : modelLabel.slice(makePrefix.length);
};

/**
 * Resolves a catalogue key (make, model family or trim) to its label. Falls back to the raw key
 * while the catalogue is loading or when the key is unknown.
 */
export const resolvePurchasePriceRuleLabel = (params: ResolvePurchasePriceRuleLabelParams) => {
  const make = params.catalogue?.makes[params.key];
  const modelFamily = params.catalogue?.models[params.key];

  return match({make, modelFamily})
    .with({make: Pattern.not(Pattern.nullish)}, (resolved) => resolved.make.label)
    .with({modelFamily: Pattern.not(Pattern.nullish)}, (resolved) =>
      stripMakePrefix(
        resolved.modelFamily.label,
        params.catalogue?.makes[resolved.modelFamily.make]?.label
      )
    )
    .otherwise(() => params.trims?.find((trim) => trim.value === params.key)?.label ?? params.key);
};
